/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Agents from './agents-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Agents {...validProps} />;
}

SvgComponent.iconName = 'agents';

export const AgentsIcon = svgIconWrapper(SvgComponent);
